module.exports = __webpack_public_path__ + "static/media/google-choose.fe80978d.svg";